// extracted by mini-css-extract-plugin
module.exports = {"priceBreakDown":"OrderSummaryBreakDown-module__priceBreakDown___2JGth","price":"OrderSummaryBreakDown-module__price___3MJgL"};